import React from "react";
import "./HomeNews.scss";
import { NavLink } from "react-router-dom";
import HomeNewsCard from "./HomeNewsCard/HomeNewsCard";

/*
  active — секция показана на самой странице новостей: ссылка «Все новости»
  там вела бы сама на себя, поэтому её не рисуем.
*/
const HomeNews = ({ active, newsData }) => {
  return (
    <div className="homeNews_container" id="news">
      <div className="homeNews_block">
        <div className="homeNews_head">
          <div className="homeNews_title">
            <h1>Новости и Акции</h1>
            <p>
              Блог о современных технологиях для бизнеса и частных лиц. Цифровые
              продукты и решения для простых пользователей и профессионалов.
            </p>
          </div>
          {!active && (
            <NavLink to="/news" className="homeNews_all">
              Все новости <span aria-hidden="true">→</span>
            </NavLink>
          )}
        </div>
        <HomeNewsCard newsData={newsData} />
      </div>
    </div>
  );
};

export default HomeNews;
